import api from "./client";

export { timeOffErrorMessage } from "./timeOffErrors";

/* Time off — bound to the COMPLETE, live workflow at
   /api/scheduling/time-off-requests/ (verified 200, 2026-09-08). D's HR spec:
   the backend was never broken, the web just never called it — this is the
   nav home + request→approve flow it lacked. Approval writes a
   TechAvailability block server-side, so the dispatch board honors it. */

export const CATEGORIES = [
  { value: "vacation", label: "Vacation" },
  { value: "sick", label: "Sick leave" },
  { value: "pto", label: "PTO" },
  { value: "unpaid", label: "Unpaid leave" },
  { value: "training", label: "Training" },
  { value: "other", label: "Other" },
];

// GET 200 → DRF page { count, results: [...] } (or a bare list)
export const listTimeOff = (params = {}) =>
  api.get("/scheduling/time-off-requests/", { params });

// POST — { tech (TechnicianProfile id, required), category, start_date,
//   end_date, hours?, reason? }
export const createTimeOff = (body) =>
  api.post("/scheduling/time-off-requests/", body);

// PATCH …/<id>/approve/ | deny/ — body {note?} (one line, kept on the request).
// 409 unless still pending; past-dated requests approve like any other (it
// happened, it still counts). Returns the updated row incl. reviewed_by_name.
export const approveTimeOff = (id, body = {}) =>
  api.patch(`/scheduling/time-off-requests/${id}/approve/`, body);
export const denyTimeOff = (id, body = {}) =>
  api.patch(`/scheduling/time-off-requests/${id}/deny/`, body);
export const cancelTimeOff = (id) =>
  api.patch(`/scheduling/time-off-requests/${id}/cancel/`, {});

// Does approving this break the schedule? CRM schedule stops for the request's tech, per day.
// 404 until the backend that adds it is deployed.
export const getTimeOffConflicts = (id) => api.get(`/scheduling/time-off-requests/${id}/conflicts/`);

// Per-employee PTO allowance on the employment record (EmploymentProfile id).
// { days_per_year, accrual: "annual_grant"|"monthly", carryover, year_start }
// → { allowance: null | {days_per_year, accrual, carryover, year_start,
//     accrued_days, carry_in_days, used_days, pending_days, days_left} }.
// null days_per_year clears it back to "PTO not set".
export const setPtoAllowance = (employmentId, body) =>
  api.patch(`/people/employees/${employmentId}/pto-allowance/`, body);
